import axios from 'axios';
import ServerProperties from '../../config/server.js'
import {RequestinProcess,AddPaginationURL} from '../../helper/request.action.js'

let result = []

const fillEmpty = (val, replace) => {
  if (val === undefined || val === null || val === ""){
    return replace;
  } else {
    return val;
  }
}

export default {
  Register: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API+'Asset/Register/',
      {
        Tag                : params.data.Tag,
        Name               : params.data.Name,
        Description        : params.data.Description,
        SerialNumber       : params.data.SerialNumber,
        PurchasedDate      : params.data.PurchasedDate.format('YYYY-MM-DD'),
        PurchaseCurrency   : params.data.PurchaseCurrency,
        PurchaseOrder      : params.data.PurchaseOrder,
        PurchaseVendorName : params.data.PurchaseVendorName,
        Status             : params.data.Status,
        Type               : params.data.Type,
        PurchasePrice      : fillEmpty(params.data.PurchasePrice, 0),
        Site               : params.data.Site,
        Location           : params.data.Location,
        MaxDay             : params.data.MaxDay,
        Make               : params.data.Make,
        Model              : params.data.Model,
        WarrantyPeriod     : fillEmpty(params.data.WarrantyPeriod, 0)
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    // .catch(function (error) {
    //   params.RunRedux(RequestinProcess({in_process:false,type:null}))
    //   params.onfailed(error.response)
    // });
  },
  Update: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API+'Asset/Update/'+params.data.Alias+"/",
      {
        Tag                : params.data.Tag,
        Name               : params.data.Name,
        Description        : params.data.Description,
        SerialNumber       : params.data.SerialNumber,
        PurchasedDate      : params.data.PurchasedDate.format('YYYY-MM-DD'),
        PurchaseCurrency   : params.data.PurchaseCurrency,
        PurchaseOrder      : params.data.PurchaseOrder,
        PurchaseVendorName : params.data.PurchaseVendorName,
        Status             : params.data.Status,
        Type               : params.data.Type,
        MaxDay             : params.data.MaxDay,
        Make               : params.data.Make,
        Model              : params.data.Model,
        PurchasePrice      : fillEmpty(params.data.PurchasePrice, 0),
        WarrantyPeriod     : fillEmpty(params.data.WarrantyPeriod, 0)
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data)
    });
  },
  Delete: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API+'Asset/Delete/'+params.data.Alias+"/",
      {
        Name:params.data.Name,
        PurchaseOrder : params.data.PurchaseOrder,
        PurchasePrice : params.data.PurchasePrice,
        PurchasedDate : params.data.PurchasedDate.format('YYYY-MM-DD'),
        SerialNumber:params.data.SerialNumber,
        Tag : params.data.Tag,
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data)
    });
  },
  Read: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      params.data.url === undefined ? ServerProperties.ATM_CLOUD.API+'Asset/?search='+params.data.query+'&ordering='+params.data.ordering: params.data.url,
      {
      }
    )
    .then(function (response) {
      if(params.action === 'Next'){
        result = result.concat(response.data.results)
      }else{
        result = response.data.results
      }
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("AssetSetRS",{
        next:response.data.next,
        previous:response.data.previous,
        rs:result,
        query:params.data.query
      }))
      params.onsuccess(params.self,response)
    })
    // .catch(function (error) {
    //   params.RunRedux(RequestinProcess({in_process:false,type:null}))
    //   params.RunRedux(AddPaginationURL("AssetSetRS",{next:null,previous:null,rs:[],query:''}))
    //   params.onfailed(error.response.details)
    // });
  },
  ReadAsMaster: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      ServerProperties.ATM_CLOUD.API+'Asset/Master/',
      {
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("AssetSetRS",{next:null,previous:null,rs:response.data,query:params.data.query}))
      params.onsuccess(params.self,response)
    })
    // .catch(function (error) {
    //   params.RunRedux(RequestinProcess({in_process:false,type:null}))
    //   params.RunRedux(AddPaginationURL("AssetSetRS",{next:null,previous:null,rs:[],query:''}))
    //   params.onfailed(error.response.details)
    // });
  },
}



// WEBPACK FOOTER //
// ./src/App/asset/asset/model.js